import { useState } from "react";
import { trackLead } from "tracking";
import { CircleCheckIcon } from "./icons";

const checklist = [
  "Respuesta de un asesor empresarial",
  "Propuesta ajustada a su operación",
  "Sin compromiso de compra",
];

const WHATSAPP_NUMBER = "573183759561";
const WHATSAPP_WINDOW = "kinitech-whatsapp";

function buildWhatsAppUrl(subjectPrefix, data) {
  const field = (name) => (data.get(name) || "").toString().trim();
  const optional = (name, label) =>
    field(name) ? `*${label}:* ${field(name)}` : null;

  const lines = [
    `Hola KINITECH, quiero solicitar: *${subjectPrefix}*`,
    "",
    `*Nombre:* ${field("nombre")}`,
    `*Empresa:* ${field("empresa")}`,
    optional("cargo", "Cargo"),
    optional("telefono", "Teléfono"),
    `*Correo:* ${field("correo")}`,
    `*Necesidad:* ${field("necesidad")}`,
    field("mensaje") ? `\n*Mensaje:*\n${field("mensaje")}` : null,
  ].filter((line) => line !== null);

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    lines.join("\n"),
  )}`;
}

function openWhatsApp(popup, url) {
  try {
    if (popup && !popup.closed) {
      popup.location.replace(url);
      popup.focus();
      return;
    }
  } catch (error) {
    // El navegador puede bloquear el acceso a la ventana; se usa el respaldo.
  }

  const fallback = window.open(url, WHATSAPP_WINDOW);
  if (!fallback) {
    window.location.assign(url);
  }
}

export default function QuoteSection({
  eyebrow,
  title,
  lead,
  options,
  submitLabel,
  subjectPrefix,
  trackingKey,
}) {
  const [sending, setSending] = useState(false);

  function handleSubmit(event) {
    event.preventDefault();
    if (sending) return;

    const url = buildWhatsAppUrl(subjectPrefix, new FormData(event.currentTarget));
    const popup = window.open("about:blank", WHATSAPP_WINDOW);
    setSending(true);

    trackLead(trackingKey).finally(() => {
      openWhatsApp(popup, url);
      setSending(false);
    });
  }

  return (
    <section id="contacto" className="kn-section kn-section--surface">
      <div className="kn-container kn-contact-grid">
        <div data-reveal="left">
          <span className="kn-eyebrow">{eyebrow}</span>
          <h2 className="kn-section-title">{title}</h2>
          <p className="kn-section-lead">{lead}</p>
          <ul className="kn-checklist">
            {checklist.map((item) => (
              <li key={item}>
                <CircleCheckIcon />
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="kn-form-card" data-reveal="right">
          <form className="kn-form" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="nombre">Nombre</label>
              <input
                id="nombre"
                name="nombre"
                type="text"
                placeholder="Nombre y apellido"
                required
              />
            </div>
            <div>
              <label htmlFor="empresa">Empresa</label>
              <input
                id="empresa"
                name="empresa"
                type="text"
                placeholder="Razón social"
                required
              />
            </div>
            <div>
              <label htmlFor="cargo">Cargo</label>
              <input
                id="cargo"
                name="cargo"
                type="text"
                placeholder="Compras, TI, Administración…"
              />
            </div>
            <div>
              <label htmlFor="telefono">Teléfono</label>
              <input
                id="telefono"
                name="telefono"
                type="tel"
                placeholder="+57 300 000 0000"
              />
            </div>
            <div className="field-full">
              <label htmlFor="correo">Correo corporativo</label>
              <input
                id="correo"
                name="correo"
                type="email"
                placeholder="nombre@empresa.com"
                required
              />
            </div>
            <div className="field-full">
              <label htmlFor="necesidad">Necesidad</label>
              <select id="necesidad" name="necesidad" defaultValue="" required>
                <option value="" disabled>
                  Seleccione una opción
                </option>
                {options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            <div className="field-full">
              <label htmlFor="mensaje">
                Mensaje{" "}
                <span style={{ color: "var(--kn-muted)" }}>(opcional)</span>
              </label>
              <textarea
                id="mensaje"
                name="mensaje"
                rows={4}
                placeholder="Cuéntenos brevemente su requerimiento"
              />
            </div>
            <div className="field-full">
              <button
                type="submit"
                className="kn-btn-primary kn-btn-primary--block"
                disabled={sending}
              >
                {sending ? "Enviando…" : submitLabel}
              </button>
              <p className="kn-form-note">
                Al enviar acepta la política de tratamiento de datos de
                KINITECH.
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
